export const data = {
    name: "Injection",
    layout: [],
};
export default data;